import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

/** Native app-style top bar for internal mobile pages.
 *  Dark navy hero with back button, title and optional right action. */
export default function MobileScreenHeader({ title, subtitle, right = null, sticky = false, testid }) {
    const navigate = useNavigate();
    return (
        <div
            className={`text-on-image ${sticky ? "sticky top-0 z-30" : ""}`}
            style={{ background: "linear-gradient(180deg, #001a3d 0%, #002657 100%)" }}
            data-testid={testid}
        >
            <div className="flex items-center gap-2 px-3 py-3">
                <button
                    type="button"
                    onClick={() => navigate(-1)}
                    aria-label="Back"
                    data-testid="mob-header-back"
                    className="w-9 h-9 rounded-full flex items-center justify-center bg-white/12 backdrop-blur-md border border-white/20 active:scale-95 transition-transform"
                >
                    <ChevronLeft className="w-5 h-5 text-white" />
                </button>
                <div className="flex-1 min-w-0">
                    <div className="font-heading font-extrabold text-white text-[15px] leading-tight truncate">
                        {title}
                    </div>
                    {subtitle && (
                        <div className="text-[11px] leading-tight truncate" style={{ color: "#F5E5A5" }}>
                            {subtitle}
                        </div>
                    )}
                </div>
                {right}
            </div>
        </div>
    );
}
